import {
  ReportImpact,
  ReportReadStatus,
  ReportSourceType,
  ReportTypeCategory,
} from '@/core/interfaces/common';
import { AutoDateRange } from '@/core/interfaces/filters';

import { ResolvedMedia } from '@/features/Reports/media-resolution/types';

export type ReportLocation = {
  latitude: number;
  longitude: number;
  address: string;
};

export type ReportCountry = {
  region: {
    name: string;
    countries: [
      {
        name: string;
      },
    ];
  };
};

export type ReportCategory = {
  mainCategory: {
    id: number;
    name: string;
    mainCategorySvg: string | null;
    subcategories: [
      {
        id: number;
        name: string;
        subCategorySvg: string | null;
      },
    ];
  };
};

export type ReportVictims = {
  dead: number;
  wounded: number;
  hostages: number;
  missing: number;
  arrested: number;
};

export enum SourceCredibility {
  RELIABLE = 'Reliable',
  PARTIALLY_RELIABLE = 'Partially Reliable',
  UNRELIABLE = 'Unreliable',
  UNKNOWN = 'Unknown',
  EMPTY = 'Empty',
  DASH = '-',
}

export type ReportSource = {
  id?: number;
  url: string;
  title?: string | null;
  name?: string | null;
  publishedDatetime?: string | null;
  image?: string | null;
  credibility?: SourceCredibility | null;
  resolvedMedia?: ResolvedMedia | null;
};

export enum EventReportTime {
  MORNING = 'morning',
  MIDDAY = 'midday',
  AFTERNOON = 'afternoon',
  EVENING = 'evening',
  NIGHT = 'night',
}

export type ReportResponseItem = {
  reportId: number;
  reportTitle: string;
  content: string;
  location: Array<ReportLocation>;
  country: Array<ReportCountry>;
  eventDate: string;
  eventTime: EventReportTime | string | null;
  eventEndDate: string | null;
  eventEndTime: string | null;
  publishedDatetime: string;
  modifiedDatetime: string;
  category: Array<ReportCategory>;
  reportType: ReportTypeCategory;
  impact: ReportImpact;
  victims: ReportVictims;
  source: Array<ReportSource>;
};

export type ReportResponseItemWithReadStatus = ReportResponseItem & {
  readStatus: ReportReadStatus | null;
};

export type ReportsListResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  results: Array<ReportResponseItem>;
  totalPages: number;
};

export type ReportsListData = {
  page?: number;
  pageSize?: number;
  autoDateRange?: AutoDateRange | null;
  category?: Array<number>;
  country?: Array<number>;
  eventStartDate?: string | null;
  eventEndDate?: string | null;
  geofeatureCoordinates?: string;
  impact?: Array<ReportImpact>;
  keyword?: string;
  publishedSinceSeconds?: number | null;
  reportType?: Array<ReportTypeCategory>;
  sourceCredibility?: Array<SourceCredibility>;
};

export type Report = ReportResponseItem & {
  reportSourceType: ReportSourceType;
  wasOpened: boolean;
  readStatus: ReportReadStatus | null;
};
